import Cookies from 'js-cookie';
import { browserHistory } from '@americanexpress/one-app-router';
import redirect from './redirect';
import {
  SUPPORTED_LOCALES,
} from './scripts/constants';

// Cookie related functions

const profileType = {
  account: 'default',
  rewards: 'default',
  work: 'default',
  merchant: 'default',
  abacus: 'abacus',
  reconciliation: 'default',
};

export const getProfileType = (destination) => profileType[destination];

export const getProfileCookie = () => Cookies.get('profile');

export const parseEidProfile = () => (localStorage.getItem('eid-profile') ? JSON.parse(localStorage.getItem('eid-profile')) : {});

export const initializeEidProfile = () => {
  if (!localStorage.getItem('eid-profile')) {
    const profileCookie = getProfileCookie(); // browser cookie
    const cookie = { default: profileCookie };
    localStorage.setItem('eid-profile', JSON.stringify(cookie));
  }
};

export const shouldRedirectToInstantProfile = (marketFlag) => !window.location.pathname.includes('/oauth/login') && marketFlag;

export const getProfileUser = () => {
  const rawProfile = getProfileCookie();
  let profile = {};

  if (rawProfile) {
    profile = rawProfile.split('|').reduce((last, current) => {
      const keyVal = current.split('#');
      return { ...last, [keyVal[0]]: keyVal[1] };
    }, {});
  }
  return profile.muid;
};

// set cookie to LocalStorage
export const setLocalStorageCookie = (destination) => {
  if (global.BROWSER) {
    const key = getProfileType(destination);
    const oldCookie = parseEidProfile();
    const cookie = { ...oldCookie, [key]: getProfileCookie() };
    localStorage.setItem('eid-profile', JSON.stringify(cookie));
  }
};

// set cookie from localStorage
export const setProfileCookieFromLocalStorage = (destination) => {
  // get cookie
  const cookieKey = getProfileType(destination.key || destination.overrideKey);
  const localStorageCookie = parseEidProfile();
  const cookie = localStorageCookie[cookieKey];
  // set Cookie
  if (cookie) {
    Cookies.set('profile', cookie, { path: '/', domain: '.americanexpress.com' });
  } else {
    Cookies.remove('profile', { path: '/', domain: '.americanexpress.com' });
  }
};

// Link related functions
export function deepLink(link, attribute, keylist) {
  let obj = link;
  let n = 0;

  while (obj) {
    if (obj[attribute] !== undefined) {
      return obj[attribute];
    }
    obj = obj[keylist[n++]];
  }

  return '';
}

// destination is either a full url, e.g. https://online.americanexpress.com/...
// or a route, e.g. /dashboard
export function winDestinationUrl(win, dest) {
  return dest.slice(0, 4).toLowerCase() === 'http'
    ? dest
    : `${win.location.protocol}//${win.location.host}${dest}`;
}

export function destinationUrl(dest) {
  return winDestinationUrl(window, dest);
}

export function verifyEncodedUrl(url) {
  let href = url;
  // check if url has slash encoded
  if (href.includes('%2F')) {
    href = decodeURIComponent(href);
  }
  // check if url has question mark encoded
  if (href.includes('%3F')) {
    href = decodeURIComponent(href);
  }
  return href;
}

// redirect user to supplied url or route,
export function setAppLocation(url, doReplace) {
  if (typeof url === 'string') {
    let href = verifyEncodedUrl(url);
    if (href.toLowerCase().startsWith('http')) {
      return redirect(href);
    }
    // treat as a route - should start with slash, otherwise
    // user lands on /login/href instead of /href
    if (!href.startsWith('/')) {
      href = `/${href}`;
    }
    return doReplace
      ? browserHistory.replace(href)
      : browserHistory.push(href);
  }

  return {};
}

// Miscellaneous functions
export const qualifyUrl = (url, location) => {
  const href = verifyEncodedUrl(url);

  if (href.startsWith('http')) {
    return href;
  }

  const slash = href.startsWith('/') ? '' : '/';

  if (global.BROWSER) {
    return `${window.location.protocol}//${window.location.host}${slash}${href}`;
  }

  return `${location.protocol}//${location.host}${slash}${href}`;
};

export const shouldPasswordMigrate = (
  dateOfLastPasswordChange,
  localeDate,
  queryForceChangeDate
) => {
  if (!dateOfLastPasswordChange || Number.isNaN(Date.parse(dateOfLastPasswordChange))) {
    return false;
  }
  if (!localeDate || Number.isNaN(Date.parse(localeDate))) {
    return false;
  }

  if (queryForceChangeDate && !Number.isNaN(Date.parse(queryForceChangeDate))) {
    return Math.sign(
      Date.parse(dateOfLastPasswordChange) - Date.parse(queryForceChangeDate)
    ) <= 0;
  }
  return Math.sign(
    Date.parse(dateOfLastPasswordChange) - Date.parse(localeDate)
  ) <= 0;
};

export const getLocaleFromCookie = (locale) => {
  const cookieLocale = (Cookies.get('axplocale') || '').toLowerCase();
  // In rare cases the cookie locale can be set to unsupported locale, handle it here.
  const isSupportedLocale = SUPPORTED_LOCALES.includes(cookieLocale);

  return isSupportedLocale ? cookieLocale : locale;
};

export const getEidParam = () => JSON.parse(sessionStorage.getItem('eidParam')) || {};

export const getUserProducts = ({ products, type }) => {
  if (!products || !Array.isArray(products)) {
    return false;
  }
  return products.includes(type);
};
